export default "__VITE_ASSET__DKmHxwoN__"